import { useState } from "react";

const useCreateSchedule = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const createSchedule = async (scheduleData) => {
    setLoading(true);
    setError("");
    setSuccess(false);

    const token = localStorage.getItem("authToken");

    if (!token) {
      const errorMessage = "Token de autenticação não encontrado";
      setError(errorMessage);
      setLoading(false);
      return {
        success: false,
        error: errorMessage,
      };
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/webapp/create/schedule`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            jwt: token,
          },
          body: JSON.stringify(scheduleData),
        }
      );

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        return {
          success: true,
          message: data.message || "Agendamento criado com sucesso",
          data: data,
        };
      } else {
        setError(data.message || "Erro ao criar agendamento");
        return {
          success: false,
          error: data.message || "Erro ao criar agendamento",
        };
      }
    } catch (err) {
      const errorMessage = "Erro ao criar agendamento. Tente novamente.";
      setError(errorMessage);
      return {
        success: false,
        error: errorMessage,
      };
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError("");
  };

  const clearSuccess = () => {
    setSuccess(false);
  };

  return {
    createSchedule,
    loading,
    error,
    success,
    clearError,
    clearSuccess,
  };
};

export default useCreateSchedule;
